(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beyond-hmt-transparency"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const openBtn = event.target.closest('[data-hmt-modal-open]');
    if (openBtn) {
      const root = openBtn.closest('[data-hmt-transparency]');
      const dialog = root && root.querySelector('[data-hmt-modal]');
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
      return;
    }

    const closeBtn = event.target.closest('[data-hmt-modal-close]');
    if (closeBtn) {
      const dialog = closeBtn.closest('dialog');
      if (dialog) dialog.close();
    }
  });

  document.addEventListener('click', (event) => {
    if (event.target.matches('dialog[data-hmt-modal]')) {
      event.target.close();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
